import { Link } from "react-router-dom";

import { ASSETS, BRAND } from "@/config/brand";

/**
 * Premium two-panel auth layout. Navy brand panel (left) + form (right).
 * Fully responsive: the brand panel collapses to a compact header on mobile.
 */
export const AuthLayout = ({ title, subtitle, children, footer }) => {
  return (
    <div className="grid min-h-screen lg:grid-cols-[1.05fr_1fr]">
      {/* Brand panel */}
      <div className="relative hidden flex-col justify-between overflow-hidden bg-brand-navy p-10 text-white lg:flex xl:p-14">
        <div
          className="pointer-events-none absolute inset-0 opacity-[0.12]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 20%, rgba(212,175,55,0.5), transparent 42%), radial-gradient(circle at 80% 75%, rgba(16,42,67,0.9), transparent 45%)",
          }}
        />
        <div className="relative">
          <img src={ASSETS.wordmark} alt={BRAND.company} className="h-9 w-auto" />
        </div>
        <div className="relative max-w-md">
          <p className="font-brand text-4xl leading-tight text-white xl:text-5xl">
            The operating system for the business of real estate.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-white/60">
            {BRAND.product} brings your entire business into one intelligent workspace — built on the RESIDENNCE platform.
          </p>
        </div>
        <div className="relative flex items-center gap-3 text-xs uppercase tracking-[0.28em] text-white/40">
          <span className="h-px w-8 bg-brand-gold/50" />
          Built for the business of real estate
        </div>
      </div>

      {/* Form panel */}
      <div className="flex flex-col justify-center bg-background px-5 py-10 sm:px-10">
        <div className="mx-auto w-full max-w-md">
          {/* Mobile brand mark */}
          <div className="mb-8 flex items-center gap-3 lg:hidden">
            <img src={ASSETS.mark} alt={BRAND.company} className="h-10 w-10" />
            <span className="font-brand text-lg font-semibold tracking-[0.14em] text-brand-navy">
              {BRAND.company}
            </span>
          </div>

          <div className="mb-8">
            <h1 className="font-brand text-3xl font-semibold text-foreground">{title}</h1>
            {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
          </div>

          {children}

          {footer && <div className="mt-8 text-center text-sm text-muted-foreground">{footer}</div>}

          <p className="mt-10 text-center text-[11px] text-muted-foreground/70">
            © {new Date().getFullYear()} {BRAND.company}. {BRAND.product} is a product of RESIDENNCE.
          </p>
        </div>
      </div>
    </div>
  );
};

export const AuthLink = ({ to, children, testId }) => (
  <Link to={to} data-testid={testId} className="font-semibold text-accent underline-offset-4 hover:underline">
    {children}
  </Link>
);
